<template>
  <div id="top_content">
    <img :src="getImage('top/content/user.webp')" v-if="!isHaseko">
    <section v-if="!isHaseko">
      <h2 id="top_title">
        <p id="title_pc">サイズオーダー収納の専門店&nbsp;&nbsp;&nbsp;&nbsp;mm/style（ミリスタイル）</p>
        <p id="title_sp">サイズオーダー収納の専門店<br>mm/style（ミリスタイル）</p>
      </h2>
      <article class="article_photo president_photo">
        <!-- <div>
          <img :src="getImage('common/noimage.png')" style="width:20rem;">
        </div> -->
        <div>
          <p>
            収納家具を「ご希望のサイズ」でお作りいたします。<br>
            お客様の収納スペースに合わせて、ご希望のサイズをmm単位でオーダーできます！<br>
            トイレや冷蔵庫上の吊戸棚（フロート収納）、食器棚（カップボード）、壁面収納など、多くのご注文をいただいております。<br>
            「サイズの決め方が分からない」「どうやって買えば良いの？」といった方は、まずはご相談ください。<br>
            <br>
            <!-- <span class="bold">mms/tyle運営企業 ドゥーマンズ株式会社 代表 二宮健一</span> -->
          </p>
        </div>
      </article>
      <div v-if="!isHaseko">
        <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
      </div>
    </section>
    <section>
      <h2>商品カテゴリから選ぶ</h2>
      <article class="category_list">
        <div>
          <div class="category" @click="routeCategory({cid: 1})">
            <img :src="getImage('top/content/category_WS.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 2})">
            <img :src="getImage('top/content/category_CB.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 3})">
            <img :src="getImage('top/content/category_SC.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 4})">
            <img :src="getImage('top/content/category_counter.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 5})">
            <img :src="getImage('top/content/category_tan.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 6})">
            <img :src="getImage('top/content/category_UC.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 7})">
            <img :src="getImage('top/content/category_SB.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 8})">
            <img :src="getImage('top/content/category_TV.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 9})">
            <img :src="getImage('top/content/category_BSDK.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 14})">
            <img :src="getImage('top/content/category_CL.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 15})">
            <img :src="getImage('top/content/category_NS.webp')">
          </div>
        </div>
        <div v-if="!isHaseko">
          <div class="category" @click="routeCategory({cid: 16})">
            <img :src="getImage('top/content/category_Closet.webp')">
          </div>
        </div>
        <div v-if="!isHaseko">
          <div class="category" @click="routeCategory({cid: 17})">
            <img :src="getImage('top/content/category_WB.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 18})">
            <img :src="getImage('top/content/category_PS.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 19})">
            <img :src="getImage('top/content/category_floor.webp')">
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory({cid: 20})">
            <img :src="getImage('top/content/category_wall.webp')">
          </div>
        </div>
      </article>
      <div class="other_btn" @click="routeCategory()">商品を選ぶ 〉〉</div>
    </section>
    <section id="location_select">
      <h2>場所から選ぶ</h2>
      <article id="location_list">
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_living.webp')">
            <div>
              <div>リビング</div>
              <ul>
                <li @click="routeCategory({cid: 1})"><a>吊戸棚（フロート収納）</a></li>
                <li @click="routeCategory({cid: 8})"><a>テレビボード</a></li>
                <li @click="routeCategory({cid: 4})"><a>カウンター</a></li>
                <li @click="routeCategory({cid: 5})"><a>棚板・フィラー</a></li>
                <li @click="routeCategory({cid: 7})"><a>サイドボード</a></li>
                <li v-if="!isHaseko" @click="routeCategory({cid: 16})"><a>可動間仕切収納</a></li>
                <li @click="routeCategory({cid: 18})"><a>シェルフ</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_dining.webp')">
            <div>
              <div>ダイニング</div>
              <ul>
                <li @click="routeCategory({cid: 6})"><a>カウンター下収納</a></li>
                <li @click="routeCategory({cid: 7})"><a>サイドボード</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_kitchen.webp')">
            <div>
              <div>キッチン</div>
              <ul>
                <li @click="routeCategory({cid: 2})"><a>食器棚（カップボード）</a></li>
                <li @click="routeCategory({cid: 15})"><a>隙間収納</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_bath.webp')">
            <div>
              <div>洗面所・バス</div>
              <ul>
                <li @click="routeCategory({cid: 1})"><a>吊戸棚（フロート収納）</a></li>
                <li @click="routeCategory({cid: 15})"><a>隙間収納</a></li>
                <li v-if="!isHaseko" @click="routeCategory({cid: 17})"><a>洗面台</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_den.webp')">
            <div>
              <div>書斎・クローゼット</div>
              <ul>
                <li @click="routeCategory({cid: 9})"><a>本棚・デスク</a></li>
                <li @click="routeCategory({cid: 14})"><a>クローゼット収納</a></li>
                <li v-if="!isHaseko" @click="routeCategory({cid: 16})"><a>可動間仕切収納</a></li>
                <li @click="routeCategory({cid: 18})"><a>シェルフ</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <img :src="getImage('top/content/floor_entrance.webp')">
            <div>
              <div>玄関・エントランス</div>
              <ul>
                <li @click="routeCategory({cid: 3})"><a>玄関収納</a></li>
              </ul>
            </div>
          </div>
        </div>
      </article>
      <div v-if="!isHaseko">
        <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
      </div>
    </section>
    <!-- <section>
      <h2>施工事例を一部紹介</h2>
      <div class="construct_list">
        <ul>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <div>【〇〇地方の〇〇】施設名（〇〇市）</div>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
        </ul>
      </div>
      <div class="detail_btn2 btn_pos_center" @click="route('DcConstructModel')">施工事例をもっと見る 〉〉</div>
    </section> -->
    <!-- <section>
      <h2>お客様からいただいた貴重な声</h2>
      <div class="user_comment">
        <ul>
          <li>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
          <li>
            <img :src="getImage('common/noimage.png')" style="width:15rem;">
          </li>
        </ul>
      </div>
      <div class="detail_btn2 btn_pos_center">お客様の声をもっと見る</div>
    </section> -->
    <!-- <section>
      <h2>顧客インタビュー</h2>
      <div class="user_interview">
        <ul>
          <li>
            <h3>業者様の声</h3>
            <div>
              <p>
                収納家具がピッタリ合うだけで「こんなに部屋のイメージが変わるのか！」とお客様に喜んで頂きました。
                提案する側も1㎜単位でサイズを提案でき、自信をもってお客様におススメできるのでとても便利です。」
              </p>
              <div class="interview_dtl_btn">インタビュー詳細はこちら</div>
            </div>
          </li>
          <li>
            <h3>お施主様の声</h3>
            <div>
              <p>
                「ジャストサイズで高級感があり、希望の場所に施工できたので自信を持って部屋を案内できるのでとても気に入っています。
                カラーバリエーションも豊富で希望のイメージを実現できました。
              </p>
              <div class="interview_dtl_btn">インタビュー詳細はこちら</div>
            </div>
          </li>
        </ul>
      </div>
    </section> -->
    <!-- お客様に選ばれる3つの理由 -->
    <section>
      <h2>お客様に選ばれる3つの理由</h2>
      <dd-reason />
    </section>
    <!-- お知らせ情報 -->
    <!-- <nav class="info_tab">
      <h2>お知らせ</h2>
      <ul>
        <li>新着情報</li>
        <li>重要なお知らせ</li>
        <li>キャンペーン</li>
        <li>プレスリリース</li>
        <li>出荷情報</li>
      </ul>
    </nav> -->
    <!-- mm/style 3つの安心ポリシー -->
    <!-- <div>
      <div class="triangle_line"><div></div><div></div></div>
      <h1>mm/style３つの安心ポリシー</h1>
      <div class="user_select">
        <div class="user_select2">
          <div>
            <span>1. </span>
            <span class="pickup_title">安心のサポート</span>
          </div>
          <div>
            弊社の専門スタッフのサービスを行って。<br>
            ※通常の環境下おいて、本製品の施工完了日（既存建物の場合）又は同設置建物の完工日（新築建物の場合）より10年間とします。<br>
            尚、本保証内容によって修理が行われた場合の保証期間は、修理後６か月、または当初保証期間の残余期間のいずれかの長い日数とします。
          </div>
        </div>
      </div>
      <div class="user_select">
        <div class="user_select2">
          <div>
            <span>2. </span>
            <span class="pickup_title">返品・返金保証</span>
          </div>
          <div>
            返品・返金承ります。（返品送料はお客様負担となります）<br>
            ※次の場合は返品返金できません。<br>
            ・お客様が傷をつけるなどして破損した商品は返品できません。<br>
            ・お届け後7日以上たっている場合は返品できません。<br>
            お届けした時と全く同じ状況での返品が条件になります。
          </div>
        </div>
      </div>
      <div class="user_select">
        <div class="user_select2">
          <div>
            <span>3. </span>
            <span class="pickup_title">3年間品質保証</span>
          </div>
          <div>
            運送中に製品が破損した場合にも保証します。<br>
            ※商品の品質には万全を期しておりますが、万一発送中の破損（割れ、商品の漏れ、欠け等）がございましたら、14日以内にご連絡下さい。至急、最短期間で新しい商品と交換させていただきます。<br>
            <br>
            ●安心のサポート制度<br>
            商品について質問や疑問があればmm/styleのスタッフが迅速にお答えいたします。お問い合わせは、下記の電話番号またはメールアドレスにてお願い致します。<br>
          </div>
        </div>
      </div>
      <div class="support_bunner">
        <div>
          <div></div>
          <div class="support_msg">
            <div>お急ぎの方はご連絡ください</div>
            <div>TEL : 03-6276-1123</div>
            <div>月～金曜 10:00～18:00（定休：土日祝）</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <section class="infomation">
      <h2>お知らせ</h2>
      <ul>
        <li v-for="(news, index) in viewNewsList" class="news" :key="'news-' + index" :value="news">
          <div>{{news.opInfoStartdt}}</div>
          <div>{{news.opInfoTitle}}</div>
        </li>
      </ul>
      <div class="detail_btn2 btn_pos_center" @click="route('DcNews')">お知らせ一覧へ</div>
    </section> -->
    <div v-if="!isHaseko">
      <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

import * as App from '../../../utils/App'
import DDReason from '../../components/top/DcSelectReason'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED, DC_PRPIC_ON} from '../../../constants/App'

const NEWS_VIEW_SIZE = 4

export default {
  components: {
    'dd-reason': DDReason
  },
  data () {
    return {
      userInfo: {}
    }
  },
  computed: {
    ...mapState({
      newsList: state => state.newsList
    }),
    viewNewsList: function () {
      if (!this.newsList) return []
      let list = this.newsList.filter(function (element, index) {
        return (index >= 0 && index < NEWS_VIEW_SIZE)
      })
      return list
    },
    isHaseko: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    ...mapActions({ getNewsList: 'loadNewsList' }),
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (params) {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      if (DC_PRPIC_ON === 1) {
        this.$router.push({
          name: 'DcPrpic',
          query: params
        })
      } else {
        this.$router.push({
          name: 'DcCategory',
          query: params
        })
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('loadNewsList', {reload: true})
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/DcTopContent.vue